<app-data-setup-common-content [isIos]="true" [isTmo]="true"></app-data-setup-common-content>
<div class="ios-tmo-container page-section">
    <section class="title-section">
        <div class="image-part">
            <img src="assets/icon/ios-icon.svg" width="40" height="42" alt="IOS Icon">
        </div>
        <h4>iPhone LTE Instructions:</h4>
    </section>
    <div class="info-banner default-background">
        <div class="flex">
            <img src="assets/icon/banner-info-icon.svg" width="32" height="32" alt="Info Icon">
            <div class="banner-content">
                <h5 class="title">Note:</h5>
                <p class="smaller desc-a">To ensure your carrier settings are up to date, go to:</p>
                <p class="smaller desc-b"><b>Settings > General > About > Carrier</b></p>
                <p class="smaller desc-a last">If prompted to update your carrier settings, select <b>Update.</b></p>
            </div>
        </div>
    </div>
    <section class="instructions-section">
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-one-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Select the <b>Settings</b> icon on your home screen.</p>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-two-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Select the <b>Cellular menu</b> option in the first section of the menu.</p>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-three-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Select <b>Cellular Data Options</b></p>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-four-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Select <b>Voice & Data</b>, Select <b>LTE</b> & turn on <b>VoLTE</b></p>
        </div>
        <div class="flex-text bottom">
            <div class="number-image">
                <img src="assets/icon/circle-five-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Select the <b>Cellular Data Network</b> option & enter the following information into the fields:</p>
        </div>
        <div class="information-part">
            <div class="box desktop">
                <div class="box-title">
                    <p><b>Cellular Data</b></p>
                </div>
                <div class="key-value-flex" *ngFor="let info of iosInfoDetails.slice(0, 3)">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value" *ngIf="!info.href">{{info.value}}</p>
                    <p class="smaller value" *ngIf="!!info.href"><a class="word-break"
                            href="http://wholesale.mmsmvno.com/mms/wapenc">{{info.value}}</a></p>
                </div>
            </div>
            <div class="box desktop">
                <div class="box-title">
                    <p><b>MMS</b></p>
                </div>
                <div class="key-value-flex" *ngFor="let info of iosInfoDetails.slice(0)">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value">{{info.value}}</p>
                </div>
            </div>
            <div class="box responsive">
                <div class="box-title">
                    <p><b>Cellular Data</b></p>
                </div>
                <div class="key-value-flex" [class.last]="i == 2"
                    *ngFor="let info of iosInfoDetails.slice(0, 3); let i=index">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value" *ngIf="!info.href">{{info.value}}</p>
                    <p class="smaller value" *ngIf="!!info.href"><a class="word-break"
                            href="http://wholesale.mmsmvno.com/mms/wapenc">{{info.value}}</a></p>
                </div>
                <div class="box-title raduis-0">
                    <p><b>MMS</b></p>
                </div>
                <div class="key-value-flex" *ngFor="let info of iosInfoDetails.slice(0)">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value" *ngIf="!info.href">{{info.value}}</p>
                    <p class="smaller value" *ngIf="!!info.href"><a class="word-break"
                            href="http://wholesale.mmsmvno.com/mms/wapenc">{{info.value}}</a></p>
                </div>
            </div>
        </div>
        <div class="flex-text last">
            <div class="number-image">
                <img src="assets/icon/circle-six-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Restart your iPhone</p>
        </div>
    </section>
    <div class="got-it-button">
        <button class="button primary" (click)="gotIt()">Got it</button>
    </div>
</div>